"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnalyticsEvent = void 0;
const cachedEvents = [];
const AnalyticsEvent = ({
  eventCode,
  eventAction,
  additionalData
}) => {
  let dataObj = {
    "eventAction": eventAction,
    "eventCode": eventCode,
    "additionalData": additionalData
  };
  if (typeof window.ddo === 'undefined') {
    if (cachedEvents.length === 0) {
      window.addEventListener('DM_DOC_READY', e => {
        for (const dtmAnalyticsEvent of cachedEvents) {
          ssaf.sendData(dtmAnalyticsEvent);
        }
        cachedEvents.length = 0;
      });
    }
    cachedEvents.push(dataObj);
  } else {
    if (cachedEvents.length > 0) {
      for (const dtmAnalyticsEvent of cachedEvents) {
        ssaf.sendData(dtmAnalyticsEvent);
      }
      cachedEvents.length = 0;
    }
    ssaf.sendData(dataObj);
  }
};
exports.AnalyticsEvent = AnalyticsEvent;
var _default = AnalyticsEvent;
exports.default = _default;

//# sourceMappingURL=analytics-event.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@att-bit/ui-frameworks.components.analytics-event/dist/analytics-event.js
// module id = 1420
// module chunks = 8